import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import { UsuarioTecnologia } from "../../../Models/Cadastros/Usuario/UsuarioTecnologia";
import { UsuarioTecnologiaService } from "../../../Services/Cadastros/Usuario/UsuarioTecnologiaService";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import DataGridCrudComponent from "../../../Components/Forms/DataGridCrudComponent";

const UsuarioTecnologiaTab = (props: any) => {
    const [usuarioTecnologia, setUsuarioTecnologia] = useState<UsuarioTecnologia>(new UsuarioTecnologia());
    const [usuarioTecnologias, setUsuarioTecnologias] = useState<any[]>([]);
    const [tecnologias, setTecnologias] = useState<any[]>([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const usuarioTecnologiaService = new UsuarioTecnologiaService()

    const usuarioTecnologiaColunas: GridColDef[] = [
        { field: 'tecnologia_nome', headerName: 'Tecnologia', minWidth: 200, flex: 0.2, },
      ];

    useEffect(() => {
        if (props.usuario == null) {
            return;
        }

        setTecnologias(props.tecnologias);
        loadDados();
    }, [props.usuario]);

    function loadDados() {
        props.usuario.usuario_tecnologias = props.usuario.usuario_tecnologias ?? [];
        let validos = usuarioTecnologiaService.selecionarValidos(props.usuario.usuario_tecnologias);
        setUsuarioTecnologias(validos);
    }

    function adicionar() {
        let response = usuarioTecnologiaService.salvar(usuarioTecnologia, props.usuario.usuario_tecnologias);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_tecnologias = response.entities;
        loadDados();
        cancelar();
        enqueueSnackbar('Tecnologia inserida com sucesso!', {variant: 'success'});
    }

    async function apagar(id: any) {
        await confirm({ title: "Deseja realmente apagar este registro?" });

        let response = usuarioTecnologiaService.apagar(id, props.usuario.usuario_tecnologias);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_tecnologias = response.entities;
        loadDados();
        enqueueSnackbar('Tecnologia apagada com sucesso!', {variant: 'success'});
    }

    function cancelar() {
        setUsuarioTecnologia(new UsuarioTecnologia());
    }

    return (
        <div>
            <DataGridCrudComponent
                model={usuarioTecnologia}
                save={adicionar}
                cancel={cancelar}
                labelSave='Salvar'
                gridDelete={apagar}
                gridRows={usuarioTecnologias}
                gridColumns={usuarioTecnologiaColunas}
                minWidthGridActionsArea={130}
                gridHideFooter={true}
                gridHideEdit={true}
                gridFieldId='id'
                gridHeight={500}>
                <div className="col-md-4 mb-3">
                    <DropDownListComponent
                        label='Tecnologias'
                        required
                        options={props.tecnologias}
                        valueField='id'
                        textField='descricao'
                        model={usuarioTecnologia}
                        modelField='tecnologia_id'
                        modelFieldName='tecnologia_nome' />
                </div>
            </DataGridCrudComponent>
        </div>
    );
}

export default UsuarioTecnologiaTab;